<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card :loading="leaderboard.fetching" elevation="0" outlined>
          <v-tabs v-model="servers.active">
            <v-tab v-for="server in servers.data" :key="server">
              {{ server }}
            </v-tab>
          </v-tabs>
          <v-divider/>
          <v-card-text>
            <v-row>
              <v-col cols="12" v-for="(entry, key) in leaderboard.data" :key="entry.tag">
                <v-card elevation="0" outlined>
                  <v-card-title>
                    <v-icon :title="entry.pointsTotal" color="#FFD700" left v-if="key === 0">mdi-crown</v-icon>
                    <v-icon :title="entry.pointsTotal" color="#C0C0C0" left v-else-if="key === 1">mdi-crown</v-icon>
                    <v-icon :title="entry.pointsTotal" color="#cd7f32" left v-else-if="key === 2">mdi-medal-outline
                    </v-icon>
                    <span :title="entry.pointsTotal" v-else>{{ key + 1 }}</span>
                    {{ entry.tag }}
                  </v-card-title>
                  <v-card-text>
                    <v-card v-for="player in entry.leaderboardEntries" :key="player.userId"
                            :class="player.steamUser ? 'mb-2' : 'mb-2 pa-2'" elevation="0" outlined rounded>
                      <v-avatar tile class="mr-3" v-if="player.steamUser">
                        <v-img :src="player.steamUser.profilePictureUrl"></v-img>
                      </v-avatar>
                      <span v-if="player.steamUser">{{ player.steamUser.name }}</span>
                      <span v-else>{{ player.userId }}</span>

                      <span style="position: absolute;  right: 10px; top: 25%">
                        {{ (player.points / entry.pointsTotal * 100).toFixed(0) }} %
                      </span>
                    </v-card>
                  </v-card-text>

                  <leaderboard-table :leaderboard="entry.combinedPlayer" hide-default-footer
                                     disable-pagination :disabled-columns="['rank', 'userId']"/>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import LeaderboardTable from "@/components/LeaderboardTable";

export default {
  components: {LeaderboardTable},
  data: () => ({
    leaderboard: {
      fetching: false,
      initialized: false,
      data: [],
    },

    servers: {
      fetching: false,
      initialized: false,
      data: [],
      active: null,
    },

    dt: {
      leaderboard: {
        headers: [
          {value: 'rank', text: 'Rank'},
          {value: 'userId', text: 'Player'},
          {value: 'playersKilled', text: 'PvP Stats'},
          {value: 'gatheredTotal', text: 'Gathered'},
          {value: 'soldItems', text: 'Sold items'},
          {value: 'lockedCratesHacked', text: 'Locked crates hacked'},
          {value: 'cards', text: 'Card Swipes'},
          {value: 'damageDealtToPlayers', text: 'Damage dealt'},
          {value: 'damageReceivedFromPlayers', text: 'Damage received'},
          {value: 'damageReceivedFromEnvironment', text: 'Damage received (Environment)'},
          {value: 'patrolHelicoptersDestroyed', text: 'Patrol Helicopters destroyed'},
          {value: 'bradleysDestroyed', text: 'Bradleys destroyed'},
        ]
      }
    }
  }),
  methods: {
    fetchServers() {
      axios.get('/api/servers').then(r => {
        this.servers.data = [];
        this.servers.fetching = true;

        r.data.forEach(row => {
          this.servers.data.push(row.name)
        })

        this.servers.active = this.servers.length > 0 ? this.servers[0] : null;
      }).finally(() => {
        this.servers.initialized = true;
        this.servers.fetching = false;
      })
    },
    fetchClanLeaderboard(serverIdentity) {
      let url = '/api/server/' + encodeURIComponent(serverIdentity) + '/leaderboard-clans';

      this.leaderboard.fetching = true;

      axios.get(url).then(r => {
        let leaderboard = r.data.reverse();

        leaderboard.forEach(clanEntry => {
          clanEntry.leaderboardEntries.forEach(entry => {
            entry.damageDealtToPlayers = Math.round(entry.damageDealtToPlayers);
            entry.damageReceivedFromPlayers = Math.round(entry.damageReceivedFromPlayers);
            entry.damageReceivedFromEnvironment = Math.round(entry.damageReceivedFromEnvironment);

            entry.gatheredTotal = entry.gatheredWood + entry.gatheredStone + entry.gatheredMetalOre + entry.gatheredHighQualityMetalOre + entry.gatheredSulfurOre + entry.gatheredCloth;
          })
          let combinedPlayer = {};
          Object.keys(clanEntry.leaderboardEntries[0]).forEach(key => {
            if (key === 'steamUser' || key === 'serverIdentity' || key === 'userId' || key === 'mostUsedWeapon') return;

            clanEntry.leaderboardEntries.forEach(player => {
              combinedPlayer[key] = combinedPlayer[key] ? combinedPlayer[key] + player[key] : player[key];
            })
          })
          console.log(combinedPlayer);
          clanEntry.combinedPlayer = [combinedPlayer,];
        })


        this.leaderboard.data = leaderboard;
      }).finally(() => {
        this.leaderboard.initialized = true;
        this.leaderboard.fetching = false;
      })
    }
  },
  mounted() {
    this.fetchServers();
  },
  watch: {
    'servers.active': function (newVal) {
      this.fetchClanLeaderboard(this.servers.data[newVal]);
    }
  }
}
</script>